import React from "react";
import { Target, ChartNoAxesColumnIncreasing, Megaphone, Database, Plus } from "lucide-react";
import NarwhalMark from "../NarwhalMark";

const AREA_ICONS = [Target, ChartNoAxesColumnIncreasing, Megaphone, Database];

const ModelArea = ({ area, index, onOpen, active }) => {
  const Icon = AREA_ICONS[index];
  const clickable = typeof onOpen === "function";

  return (
    <article
      id={`model-area-${index}`}
      className={`model-area scroll-mt-28 ${clickable ? "model-area--clickable" : ""} ${active ? "model-area--active" : ""}`}
      data-testid={`model-area-${index}`}
      role={clickable ? "button" : undefined}
      tabIndex={clickable ? 0 : undefined}
      aria-pressed={clickable ? !!active : undefined}
      onClick={clickable ? () => onOpen(index) : undefined}
      onKeyDown={clickable ? (e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onOpen(index); } } : undefined}
    >
      <span className="model-area-terminal" aria-hidden="true" />
      {clickable && <Plus className="model-area-plus" aria-hidden="true" />}
      <header className="model-area-intro">
        <span className="model-area-icon" aria-hidden="true">
          <Icon strokeWidth={index === 1 ? 3 : 1.8} />
        </span>
        <h4 data-testid={`model-area-${index}-title`}>{area.title}</h4>
        <p data-testid={`model-area-${index}-description`}>{area.description}</p>
      </header>
    </article>
  );
};

export const ModelOrgChart = ({ chart, onAreaOpen, onRootOpen, activeAreaIndex = null, rootActive = false }) => (
  <div className="model-org-chart" data-testid="model-org-chart">
    <div
      className={`model-org-root ${typeof onRootOpen === "function" ? "model-area--clickable" : ""} ${rootActive ? "model-area--active" : ""}`}
      data-testid="model-org-root"
      role={typeof onRootOpen === "function" ? "button" : undefined}
      tabIndex={typeof onRootOpen === "function" ? 0 : undefined}
      aria-pressed={typeof onRootOpen === "function" ? rootActive : undefined}
      onClick={onRootOpen}
      onKeyDown={onRootOpen ? (e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onRootOpen(); } } : undefined}
    >
      <NarwhalMark className="model-org-logo" testId="model-org-logo" />
      <div className="model-org-root-copy">
        <h3 data-testid="model-org-root-title">{chart.root}</h3>
        <p data-testid="model-org-root-caption">{chart.rootCaption}</p>
      </div>
      {typeof onRootOpen === "function" && <Plus className="model-area-plus" aria-hidden="true" />}
    </div>

    <div className="model-org-branches" aria-hidden="true">
      <span className="model-org-trunk" />
      <span className="model-org-bus" />
      <span className="model-org-inner-branch" />
      <span className="model-org-inner-branch" />
    </div>

    <div className="model-org-areas" data-testid="model-org-areas">
      {chart.areas.map((area, index) => <ModelArea key={index} area={area} index={index} onOpen={onAreaOpen} active={activeAreaIndex === index} />)}
    </div>

    <div className="model-org-closing">
      <span className="model-org-closing-line" aria-hidden="true" />
      <p data-testid="model-org-tagline">{chart.orgTagline}</p>
      <span className="model-org-closing-line" aria-hidden="true" />
    </div>
  </div>
);